export function info({ h, w }) {
  return `
    <svg id="icon-info" viewBox="0 0 32 32" style='height: ${h}px; width: ${w}px; margin-bottom: 5px'>
      <path d="M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16v0c0-8.837-7.163-16-16-16v0zM24.348 24.348c-1.65 1.67-3.807 2.835-6.221 3.246l-0.068 0.010v-10.908h-4.146v10.908c-2.471-0.426-4.618-1.59-6.26-3.254l-0.001-0.001c-2.149-2.142-3.478-5.104-3.478-8.377 0-6.531 5.295-11.826 11.826-11.826s11.826 5.295 11.826 11.826c0 0.010 0 0.020-0 0.030v-0.002c0 0.013 0 0.029 0 0.045 0 3.245-1.319 6.181-3.45 8.302l-0 0z"></path>
      <path d="M18.783 10.435c0 1.537-1.246 2.783-2.783 2.783s-2.783-1.246-2.783-2.783c0-1.537 1.246-2.783 2.783-2.783s2.783 1.246 2.783 2.783z"></path>
    </svg>
  `;
}
